const Spaces = {
  BasePadding: '15px',
  BaseMargin: '20px',
};

export default Spaces;
